import { Component, Input } from '@angular/core';

const MEMO_TYPE_COLORS = {
  Postcard: 'rgba(79,177,166,0.8)',
  Note: 'rgba(254,211,60,0.8)',
  Flag: 'rgba(249,163,44,0.8)',
  Alert: 'rgba(241,73,33,0.8)'
};

@Component({
  selector: 'ca-memo-type-graph',
  templateUrl: './memo-type-graph.html'
})
export class MemoTypeGraph {
  typeLabels = [];
  typeData;

  public barOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    tooltips: { enabled: false },
    scales: {
      xAxes: [
        {
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            display: false
          },
          stacked: false,
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };
  public barColors = [
    {
      backgroundColor: [
        'rgba(79,177,166,0.8)',
        'rgba(254,211,60,0.8)',
        'rgba(249,163,44,0.8)',
        'rgba(241,73,33,0.8)'
      ]
    }
  ];

  @Input()
  set data(newData: Array<{ name: string; icon: string; score: string }>) {
    if (!newData) {
      return;
    }
    this.typeLabels = newData.map(item => item.name);
    this.typeData = newData.map(item => item.score);
    this.barColors = [
      {
        backgroundColor: this.typeLabels.map(label => MEMO_TYPE_COLORS[label])
      }
    ];
  }
}
